export default "__VITE_ASSET__Ce3XfMmD__"